import { Typography, Link, Fade } from "@material-ui/core";
import React from "react";
import firebase from "js/firebase";

import getLogger, { LogGroup } from "js/core/logger";
import * as analytics from "js/analytics";
import Api from "js/core/api";
import { getStaticUrl } from "js/config";
import { withFirebaseUser } from "js/react/views/Auth/FirebaseUserContext";
import { FormIcon, StandalonePage, StandaloneForm, FormTitle, StandaloneDialogContent } from "./Standalone";
import { ProgressButton } from "../../components/ProgressButton";

const logger = getLogger(LogGroup.AUTH);

const checkIcon = getStaticUrl("/images/auth/done-check.gif");

export class VerifyEmailReturn extends React.Component {
    state = {
        verified: null
    };

    async componentDidMount() {
        const code = new URL(window.location).searchParams.get("code");

        // submit the code to our API and see if its valid
        const res = await Api.verifyEmail.get({ code });

        // if it was, pull the updated firebase user
        if (res.verified) {
            // firebase needs a little time
            while (!firebase.auth().currentUser.emailVerified) {
                await firebase.auth().currentUser.reload();
            }
            await firebase.auth().currentUser.getIdToken(true);
        }

        this.setState({ verified: res.verified, reason: res.reason });
    }

    render() {
        const { verified, reason } = this.state;
        if (verified === null) {
            return null;
        } else if (verified) {
            return <VerifyEmailSuccess {...this.props} continueUrl={this.props.continueUrl} />;
        } else {
            return <VerifyEmailFailure {...this.props} continueUrl={this.props.continueUrl} reason={reason} />;
        }
    }
}

export const VerifyEmailSuccess = withFirebaseUser(class VerifyEmailSuccessImpl extends React.Component {
    state = {};

    async componentDidMount() {
        setTimeout(() => {
            this.setState({ fadeOut: true });
            setTimeout(() => {
                // user is comming from signup
                analytics.trackState({
                    "is_signing_up": true,
                });
                this.props.nextStep();
            }, 750);
        }, 1500);
    }

    render() {
        return (
            <StandalonePage>
                <Fade in={!this.state.fadeOut} timeout={750}>
                    <StandaloneForm>
                        <StandaloneDialogContent style={{ paddingBottom: 45 }}>
                            <FormIcon src={checkIcon} />
                            <FormTitle>Great! Your email has been verified.</FormTitle>
                        </StandaloneDialogContent>
                    </StandaloneForm>
                </Fade>
            </StandalonePage>
        );
    }
});

export class VerifyEmailFailure extends React.Component {
    state = {
        sentToEmail: null,
        loading: false,
        errorMessage: null
    };

    handleClickResend = async () => {
        this.setState({ loading: true });
        try {
            const { email } = await Api.verifyEmail.post();
            this.setState({ sentToEmail: email, errorMessage: null });
        } catch (err) {
            logger.error(err, "Api.verifyEmail.post() failed");
            this.setState({ errorMessage: err.message });
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const { sentToEmail, loading, errorMessage } = this.state;

        return (
            <StandalonePage>
                <StandaloneForm>
                    <StandaloneDialogContent style={{ paddingTop: 30, paddingBottom: 30 }}>
                        <FormTitle>This email verification link {this.props.reason === "expired" ? "has expired" : "is invalid"}</FormTitle>
                        <div style={{ paddingTop: 30, textAlign: "center" }}>
                            {sentToEmail && !errorMessage && <div>Sent to {sentToEmail}</div>}
                            {!sentToEmail && errorMessage && <div style={{ marginBottom: 10 }}>Error: {errorMessage}</div>}
                            {!sentToEmail && <ProgressButton
                                variant="contained"
                                color="primary"
                                onClick={this.handleClickResend}
                                loading={loading}
                            >
                                Resend Email
                            </ProgressButton>}
                        </div>
                        <Typography variant="body2" align="center" style={{ paddingTop: 20 }}>
                            Having trouble? <Link
                                href="mailto:support@beautiful.ai"
                                variant="body2"
                            >Contact support</Link>
                        </Typography>
                    </StandaloneDialogContent>
                </StandaloneForm>
            </StandalonePage>
        );
    }
}
